// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmpcIV9LOh9cM4gS62rZ8BAdDmz9Dv06E",
  authDomain: "instawiki-3b4b3.firebaseapp.com",
  projectId: "instawiki-3b4b3",
  storageBucket: "instawiki-3b4b3.appspot.com",
  messagingSenderId: "1012749363568",
  appId: "1:1012749363568:web:f4793ccdb322296ff407b5",
  measurementId: "G-RLSDJ8L79V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { db };
export { auth };